// src/utils/anexoClient.js
//
// Resolve e baixa anexos para PRÉVIA, espelhando a lógica do AnexoViewerModal:
//   • ID do Drive (alfanumérico 25–50 chars, sem "/") → /api/anexos/drive/:id
//   • Path relativo (uploads/xxx.jpg)                 → API_BASE + path
//   • URL absoluta                                    → como está
//
// O endpoint do Drive exige `Authorization: Bearer <token>`, então não dá para
// usar <img src> direto. Aqui buscamos o blob autenticado e devolvemos um
// objectURL pronto para a <img>. Cache em memória (compartilhado entre a
// galeria da tabela e a do modal) evita rebaixar o mesmo arquivo.

const API_BASE =
  import.meta.env?.VITE_API_URL ||
  process.env?.REACT_APP_API_URL ||
  '';

export function resolveAnexoUrl(raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  // Drive file ID
  if (/^[a-zA-Z0-9_\-]{25,50}$/.test(s)) return `${API_BASE}/api/anexos/drive/${s}`;
  // Path relativo
  const p = s.startsWith('/') ? s : `/${s}`;
  return `${API_BASE}${p}`;
}

function getToken() {
  try {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || '';
  } catch {
    return '';
  }
}

// Map<resolvedUrl, Promise<{ objectUrl, kind }>>
// kind: 'image' | 'pdf' | 'file'
const _cache = new Map();

export function fetchAnexoPreview(raw) {
  const url = resolveAnexoUrl(raw);
  if (!url) return Promise.reject(new Error('Anexo sem URL.'));
  if (_cache.has(url)) return _cache.get(url);

  const token = getToken();
  const promise = fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  })
    .then((res) => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.blob();
    })
    .then((blob) => {
      const mime = (blob.type || '').toLowerCase();
      const kind =
        mime.startsWith('image/')      ? 'image'
        : mime === 'application/pdf'   ? 'pdf'
        : 'file';
      const objectUrl = kind === 'image' ? URL.createObjectURL(blob) : null;
      return { objectUrl, kind };
    });

  _cache.set(url, promise);
  // Falhou → libera para nova tentativa numa próxima montagem
  promise.catch(() => _cache.delete(url));
  return promise;
}

export default fetchAnexoPreview;